import {Typography} from '@mui/material';
import Grid from '@mui/material/Grid';
import React from 'react';
import "../../css/App.css";

const SessionTimerDisplay = ({hours, minutes, seconds, isSessionStarted}) => {
  return (
    <Grid container justifyContent={"flex-end"}>
      <Grid className="show-counter">
        <Grid className={isSessionStarted ? 'session-timer session-started' : 'session-timer'}>
          <Typography variant={"subtitle2"} style={{ lineHeight: 1}}>{hours}</Typography>
          <Typography variant={"subtitle2"} style={{ lineHeight: 1}}>Hours</Typography>
        </Grid>
        <p>:</p>
        <Grid className={isSessionStarted ? 'session-timer session-started' : 'session-timer'}>
          <Typography variant={"subtitle2"} style={{ lineHeight: 1}}>{minutes}</Typography>
          <Typography variant={"subtitle2"} style={{ lineHeight: 1}}>Mins</Typography>
        </Grid>
        <p>:</p>
        <Grid className={isSessionStarted ? 'session-timer session-started' : 'session-timer'}>
          <Typography variant={"subtitle2"} style={{ lineHeight: 1}}>{seconds}</Typography>
          <Typography variant={"subtitle2"} style={{ lineHeight: 1}}>Secs</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SessionTimerDisplay;
